import React from "react";

import { FormattedDate } from "react-intl";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import LinkComponent from "../../LinkComponent";
import ShapeImgWithSubBar from "../../ShapeImgWithSubBar";
import ShapeImg from "../../ShapeImgWithSubBar/Shape";

const Headline = styled.h1`
    color: ${({ theme }) => theme.colors.white.toString()};
    font-weight: 900;
    line-height: 1.3em;
    hyphens: auto;
    font-size: 2rem;
    word-break: break-word;

    ${({ theme }) => css`
        ${theme.breakpoints.upTo.small.css`
          padding-top: 20px;
      `}
        ${theme.breakpoints.from.small.css`
          font-size: 2.5rem
      `}
        ${theme.breakpoints.from.medium.css`
          font-size: 3em;
          hyphens: unset;
          color: ${theme.colors.red.toString()};
      `}
        ${theme.breakpoints.from.normal.css`
          font-size: 3.25rem
      `}
    `}
`;

const SubBar = styled.div`
    background-color: ${({ theme }) => theme.colors.red.toString()};
    color: ${({ theme }) => theme.colors.white.toString()};
    display: grid;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: space-between;
    grid-template-columns: repeat(1, 1fr);
    justify-items: left;
    row-gap: 20px;

    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
         grid-template-columns: repeat(2, 1fr);
      `}
    `}

    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
         grid-template-columns: repeat(4, 1fr);
         align-items: flex-start;
      `}
    `}
`;

const SubItems = styled.div`
    display: flex;
    flex-direction: column;

    > div {
        ${({ theme }) =>
            theme.breakpoints.upTo.small.css`
             font-size: 1.3em;
      `}
    }

    > div:last-child {
        font-size: 1.2em;

        ${({ theme }) =>
            theme.breakpoints.upTo.small.css`
             font-size: 1.5em;
      `}
    }
`;

const JobDetail = ({ vacancy, img }) => {
    const vacancyDate = new Date(vacancy.job_start_date);

    const date =
        vacancyDate <= new Date() ? (
            <div>Ab Sofort</div>
        ) : (
            <FormattedDate value={vacancyDate} format="short" />
        );

    return (
        <ShapeImgWithSubBar>
            <ShapeImgWithSubBar.ButtonContainer>
                <LinkComponent
                    goBack
                    link={{ text: "Zurück", href: "/stellenangebote" }}
                    icon="arrow-left"
                    leftIcon
                />
            </ShapeImgWithSubBar.ButtonContainer>
            <ShapeImgWithSubBar.LeftContainer>
                <Headline>{vacancy.external_posting_name}</Headline>
            </ShapeImgWithSubBar.LeftContainer>
            <ShapeImgWithSubBar.RightContainer
                css={css`
                    background-image: url(${img});
                    background-repeat: no-repeat;
                    background-position: center left;
                    background-size: cover;
                `}
            >
                <ShapeImgWithSubBar.ImgFilter>
                    <ShapeImg />
                </ShapeImgWithSubBar.ImgFilter>
            </ShapeImgWithSubBar.RightContainer>
            <ShapeImgWithSubBar.SubBar>
                <SubBar>
                    <SubItems>
                        <div>Standort</div>
                        <div>{vacancy.geo_city}</div>
                    </SubItems>
                    <SubItems>
                        <div>Start</div>
                        {date}
                    </SubItems>
                    {vacancy.employment && (
                        <SubItems>
                            <div>Beschäftigung</div>
                            <div>{vacancy.employment}</div>
                        </SubItems>
                    )}
                    {vacancy.duration && (
                        <SubItems>
                            <div>Dauer</div>
                            <div>{vacancy.duration}</div>
                        </SubItems>
                    )}
                </SubBar>
            </ShapeImgWithSubBar.SubBar>
        </ShapeImgWithSubBar>
    );
};

export default JobDetail;
